import { render, staticRenderFns } from "./LastOrder.vue?vue&type=template&id=2046e2c4&"
import script from "./LastOrder.vue?vue&type=script&lang=js&"
export * from "./LastOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports